module.exports = __webpack_public_path__ + "5.png?745f08318d8599905c6483c80d3f627e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/5.png
// module id = 51
// module chunks = 0